<template>
  <div v-if="vehicle" class="row">
    <div class="col-md-4">
      <div class="motor">
        <div class="motor__characteristics">
          <template
            v-for="characteristic in vehicle.motors[0].characteristics"
            :key="characteristic"
          >
            <div v-if="currentCharacteristic === characteristic">
              <div class="motor__title" v-html="characteristic.label"></div>
            </div>
            <div v-else>
              <div
                class="motor__characteristic"
                @click="toggleCharacteristic(characteristic)"
              >
                <img src="/assets/images/svg/chevron-left-solid-blue.svg" />
                <span v-html="characteristic.label"></span>
              </div>
            </div>
          </template>
        </div>
      </div>
    </div>
    <div class="col-md-8">
      <div class="characteristics">
        <template v-for="field in currentCharacteristic.elements" :key="field">
          <div v-if="field.value" class="row characteristic">
            <div
              class="col-md-5 characteristic__label"
              v-html="field.label"
            ></div>
            <div class="col-md-7">{{ field.value }}</div>
          </div>
        </template>
      </div>
    </div>
  </div>
</template>

<script>
import { mapActions, mapState } from "pinia";
import { useMainStore } from "@/store";
import { getTranslation } from "@/services/translation-manager";

export default {
  name: "VehicleCharacteristicTabComponent",
  data() {
    return {};
  },
  computed: {
    ...mapState(useMainStore, {
      vehicle: (store) => store.vehicle,
      currentCharacteristic: (store) => store.characteristic,
    }),
  },
  methods: {
    getTranslation,
    toggleCharacteristic(characteristic) {
      this.setCharacteristic(characteristic);
    },

    ...mapActions(useMainStore, ["setCharacteristic"]),
  },
};
</script>

<style lang="scss" scoped>
.motor {
  position: sticky;
  top: 0;

  &__title {
    font-weight: 700;
    text-transform: uppercase;
    width: 100%;
    border-bottom: 6px solid $blue;
    padding-bottom: 0px;
    margin-bottom: 15px;
    font-size: 20px;
  }

  &__characteristics {
    &:first-child {
      .motor__characteristic {
        margin-top: 0;
      }
    }
  }

  &__characteristic {
    font-size: 18px;
    display: flex;
    align-items: center;
    line-height: 1;
    margin: 25px 0;

    img {
      height: 12px;
      transform: rotate(180deg);
      margin-right: 5px;
    }
  }
}

.characteristic {
  padding: 8px 0;
  font-size: 18px;

  &:nth-child(odd) {
    background: $white;
  }

  &__label {
    font-weight: 700;
  }
}
</style>
